import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { InscricaoAluno } from './inscricao-aluno';
import { InscricaoAlunoService } from './inscricao-aluno.service';
import { MatSnackBar } from '@angular/material';
import { RespostaListaDinamicaService } from 'unb-questionario-componente';
import { Resposta } from 'unb-questionario-componente';

@Component({
  selector: 'inscricao-aluno-detail',
  templateUrl: './inscricao-aluno-detail.component.html',
  styleUrls: [ './inscricao-aluno-detail.component.css' ]
})
export class InscricaoAlunoDetailComponent implements OnInit {
    public inscricaoAluno : InscricaoAluno;
    public isLoading: boolean;
    public botaoSalvar: boolean;
    public alunoRa: string;
    public resposta: Resposta;
    public sub : boolean = false;
    public mensagemTela: string;

    @Input() botaoSalvarInput: boolean = true;
    @Input() idInput: number;

    constructor(private route: ActivatedRoute,
      private router: Router,
      private inscricaoAlunoService: InscricaoAlunoService,
      private respostaService: RespostaListaDinamicaService,
      private mensagem: MatSnackBar)  {
    }

    ngOnInit(){
        let id:any = this.route.snapshot.params['id'];
        this.sub =this.route.snapshot.params['sub'];

        // se chegar o idInput do componente, o que vale
        if(this.idInput){
          id = this.idInput;
        }

        if (id){
          this.isLoading= true;
          this.inscricaoAlunoService.getId(parseInt(id)).subscribe(
            result => {
              this.inscricaoAluno = result;
              this.carregaResposta(this.inscricaoAluno.respostaQuestionario);
            },
            error => this.erro(error)
          );
        }else {
          this.carregaMatricula()
          this.inicializa();
        }
    }

    carregaMatricula(){
      // carrega a matricula do  usuário pelo local storage
      let storage = JSON.parse(localStorage.getItem("editaldpg"));
      let user = null;

      this.alunoRa = storage["user"];
    }

    private inicializa():void{
      this.isLoading = true;
      this.inscricaoAlunoService.inicializa(this.alunoRa).subscribe(
        result=>{
          this.inscricaoAluno = result;
          if(this.inscricaoAluno.respostaQuestionario){
            this.carregaResposta(this.inscricaoAluno.respostaQuestionario);
          }else{
            this.isLoading = false;
            this.botaoSalvar = true;
          }
        },
          error => this.erro(error)
        );
    }


    private carregaResposta(idRespostaQuestionario: number){
        this.respostaService.getRespostaCompletaPorPergunta(idRespostaQuestionario).subscribe(
          (result:Resposta) =>{
            this.resposta = result;
            if(this.resposta.id){
              if(this.sub){
                this.botaoSalvar = true;
              }else{
                // mudou a regra, agora o aluno pode alterar ateh o período fechar.
                this.botaoSalvar = true;
              }
            }else{
              this.botaoSalvar = true;
            }

            this.isLoading = false;
          },
          error =>  this.erro(error)
        );
    }

    public respostaQuestionarioEmitida(event: number){
      this.inscricaoAluno.respostaQuestionario = event;
      this.isLoading = true;
      this.mensagemTela = null;
      this.inscricaoAlunoService.update(this.inscricaoAluno).subscribe(
        result => {
          this.inscricaoAluno = result;
          this.mensagemTela = "Inscrição realizada com sucesso!";
          if(this.sub){
            this.botaoSalvar = true;
          }else{
            this.botaoSalvar = false;
          }
          this.carregaResposta(this.inscricaoAluno.respostaQuestionario);
        },
        error => {
          this.erro(error);

        }
      );
    }

    // mostra erros na tela
   erro(erro: string){
       this.mensagem.open(erro, 'X', {duration: 5000});
       this.isLoading =false;
   }






}
